/*@ngInject*/
const AdminFunctionHeaderButtonsMediator = function (adminFunctionHeaderButtonsRepository) {

    this.getAvailableAdminFunctions = function () {
        return adminFunctionHeaderButtonsRepository.getAvailableAdminFunctions();
    };
};

angular.module('gw-um-header')
    .service('adminFunctionHeaderButtonsMediator', AdminFunctionHeaderButtonsMediator);
